import useInvalidateDiaries from "@/features/diaries/features/edit/api/invalidateDiaries";
import { supabaseClient } from "@/lib/supabase";
import type { Surgery } from "@/types/database/events";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export async function upsertSurgery(surgeryData: Surgery["Insert"]) {
	const { data, error } = await supabaseClient
		.from("surgeries")
		.upsert(surgeryData)
		.select()
		.single();
	if (error) throw error;
	return data;
}

interface SurgeryMutation {
	diaryId: string;
}

export const useSurgeryMutation = ({ diaryId }: SurgeryMutation) => {
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationKey: ["upsert-surgery"],
		mutationFn: async (data: Surgery["Insert"]) => {
			return await upsertSurgery(data);
		},
		onError: () => {
			toast.error("Error creating new surgery");
		},
		onSuccess: () => {
			toast.success("Surgery saved");
		},
		onSettled: () => {
			invalidateDiaries(diaryId);
		},
	});
};
